<div class="background">
  <div class="container">
    <div class="row d-flex justify-content-center" [ngClass]="routeAnimationsElements">
      <div class="login-wrapper">
        <div class="login-title">
          <div class="brand-title">{{'auth.myBTrust' | translate}}</div>
          <div class="loginInTheSystemDescribe">{{'auth.loginInTheSystemDescribe' | translate}}</div>
        </div>
        <div *ngIf="showContentLogin">
          <div class="title-choise">
            <div [ngClass]="(operationType !== operationTypes.EMERGENCY_LOGIN) ? 'half-content' : 'full-content'">
              <mat-divider [ngClass]="(operationType !== operationTypes.EMERGENCY_LOGIN) ? 'divider-style-half' : 'divider-style'"></mat-divider>
              <span class="title-bold-blue">{{ (operationType === operationTypes.EMERGENCY_LOGIN ? 'auth.emergencyLogin.pageTitle' : 'auth.loginWithOKEP') | translate }}</span>
              <mat-divider [ngClass]="(operationType !== operationTypes.EMERGENCY_LOGIN) ? 'divider-style-half' : 'divider-style'"></mat-divider>
            </div>
            <div class="hideResponse" *ngIf="operationType !== operationTypes.EMERGENCY_LOGIN">
              {{'sentenceParts.or' | translate}}
            </div>
            <div class="half-content-right hideResponse" *ngIf="operationType !== operationTypes.EMERGENCY_LOGIN">
              <mat-divider [ngClass]="(operationType !== operationTypes.EMERGENCY_LOGIN) ? 'divider-style-half' : 'divider-style'"></mat-divider>
              <span class="title-bold-blue">{{'auth.loginWithKEP' | translate}}</span>
              <mat-divider [ngClass]="(operationType !== operationTypes.EMERGENCY_LOGIN) ? 'divider-style-half' : 'divider-style'"></mat-divider>
            </div>
          </div>
          <div class="login-content">
            <div class="container-different">
              <div class="conent-different-input" [ngClass]="getMainColumnClass()">

                <form [formGroup]="loginForm" name="form" class="tac" (ngSubmit)="f.form.valid && idLoginSubmit()"
                  #f="ngForm">

                  <div class="content-box">
                    <div *ngIf="!loading && operationType === operationTypes.LOGIN_WITH_EGN">
                      <div class="confirm-content">{{'settingsList.identeficatorRegister' | translate}}</div>
                      <section id="id-login">
                        <div class="form-group full-width divider frm-input">
                          <mat-form-field *ngIf="chooseType">
                            <mat-select [placeholder]="'auth.egnLnc' | translate" name="idType"
                              class="d-none d-sm-block" required>
                              <mat-option *ngFor="let item of idTypes" [value]="item.value"
                                (click)="onIdTypeSelect(item.value)">
                                {{ item.name | translate}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div class="form-group full-width divider frm-input">
                          <mat-form-field appearance="fill">
                            <input matInput (input)="personalId = $event.target.value" formControlName="personalId"
                              [placeholder]="'auth.personalId' | translate" class="tal" required minlength="5"
                              autocomplete="off" />
                          </mat-form-field>

                          <mat-error *ngIf="!loginForm.get('personalId').valid &&
                        loginForm.get('personalId').dirty && loginForm.get('personalId').touched"
                            class="d-none d-sm-block">
                            {{'auth.enterValidEGN' | translate}}
                          </mat-error>
                        </div>
                        <div class="row" *ngIf="captchaEnabled">
                          <div class="captcha">
                            <ngx-recaptcha2 [siteKey]="reCaptcha2SiteKey" [size]="size" [hl]="usingLang" [theme]="theme"
                              [type]="type" (expire)="handleRecaptchaExpire()" (load)="handleRecaptchaLoad()"
                              (success)="handleRecaptchaSuccess($event)" formControlName="recaptcha">
                            </ngx-recaptcha2>
                          </div>
                        </div>

                        <div class="login-btn tac">
                          <button [disabled]="loading || !loginForm.valid" class="mat-mdc-raised-button"
                            (click)="login()">
                            {{'auth.login' | translate}}
                          </button>
                        </div>

                      </section>
                      <div class="confirm-content">
                        {{'auth.confirmRequestWithOKEP' | translate}}
                      </div>
                      <button type="button"
                        *ngIf="operationType === operationTypes.LOGIN_WITH_EGN || operationType === operationTypes.EMERGENCY_LOGIN"
                        class="mat-mdc-raised-button" type="button"
                        (click)="switchLoginTo(operationTypes.LOGIN_WITH_QR)">
                        <span class="fa fa-qrcode" aria-hidden="true"></span>
                        {{'auth.withQR' | translate}}
                      </button>
                    </div>
                    <!-- Login - Emergency -->
                    <section *ngIf="operationType === operationTypes.EMERGENCY_LOGIN" class="section-emergency-login">
                      <emergency-login (goBackEmit)="switchLoginTo(operationTypes.LOGIN_WITH_EGN)"></emergency-login>
                    </section>

                    <!-- Login - QR -->
                    <section *ngIf="qrData && !loading && operationType === operationTypes.LOGIN_WITH_QR">
                      <div id="qr">
                        <qrcode [matTooltip]="'auth.loginWithQr.description.tooltip' | translate" [qrdata]="qrData"
                          [size]="'200'" [level]="'H'" [usesvg]="false"></qrcode>
                      </div>
                      <span class="auth-count">
                        <span>{{'auth.confirmTimeLeft' | translate}}</span>
                        {{timeLeft}}
                        <span>{{'auth.seconds' | translate}}</span>
                      </span>
                    </section>
                    <!-- login identificator  -->
                    <div [ngClass]="(loading || setStyle) ? 'w64' : 'w48p'">
                      <mat-spinner *ngIf="loading"></mat-spinner>
                    </div>
                    <div *ngIf="operationType !== operationTypes.TO_BE_CONFIRMED" class="actions-buttons">
                      <button *ngIf="operationType === operationTypes.LOGIN_WITH_QR" class="mat-mdc-raised-button" id="switch"
                        (click)="switchLoginTo(operationTypes.LOGIN_WITH_EGN)" type="button">
                        <span class="fa fa-address-card" aria-hidden="true"></span>
                        {{'auth.withEGN' | translate}}
                      </button>
                    </div>
                    <!--Configmation dialog -->
                    <section *ngIf="operationType === operationTypes.TO_BE_CONFIRMED">
                      <div class="auth-time-count">
                        <p translate>auth.confirmTimeLeft</p>
                        <span class="time-left">{{timeLeft}}</span>
                        <span translate>auth.seconds</span>
                      </div>
                    </section>
                  </div>
                </form>
              </div>
              <div class="vertical-divider showResponse">
                <div class="vertical-response">
                  {{'sentenceParts.or' | translate}}
                </div>
                <div class="custorm-separator">
                  <mat-divider vertical style="height:100%" class="custorm-vert-diviser"></mat-divider>
                </div>
              </div>
              <div class="half-content-right showResponse">
                <mat-divider class="divider-style-half"></mat-divider>
                <span class="title-bold-blue">{{'auth.loginWithKEP' | translate}}</span>
                <mat-divider class="divider-style-half"></mat-divider>
              </div>
              <div class="conent-different-input" [ngClass]="(loading || setStyle) ? 'w64' : 'w48p'"  *ngIf="operationType !== operationTypes.EMERGENCY_LOGIN">
                <div class="confirm-contentKEP">
                  <div class="middle-middle">
                    <div> {{'auth.loginInTheSystemDescribeKEP' | translate}}</div>
                    <div class="login-btn tac">
                      <button class="mat-mdc-raised-button" (click)="loginWihtBiss()" type="button"
                        [disabled]="operationType === operationTypes.TO_BE_CONFIRMED || loading || operationType === operationTypes.EMERGENCY_LOGIN">
                        {{'auth.login' | translate}}
                      </button>
                      <mat-error *ngIf="errorMessageCert" class="d-none d-sm-block">
                        {{'auth.errorMessageCert' | translate}}
                      </mat-error>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <section class="btn-switcher">
              <div>
                <div class="emergency-content">
                  <span *ngIf="operationType !== operationTypes.EMERGENCY_LOGIN"> {{'auth.emergencyText' |
                    translate}}</span>
                  <a *ngIf="operationType !== operationTypes.EMERGENCY_LOGIN"
                    (click)="switchLoginTo(operationTypes.EMERGENCY_LOGIN)"
                    [matTooltip]="'auth.emergencyLink.tooltip' | translate" class="cursor-pointer">
                    {{'auth.emergencyEnter' | translate}}
                  </a>
                </div>
              </div>
              <div *ngIf="operationType === operationTypes.TO_BE_CONFIRMED" class="cancel-button actions-buttons">
                <button type="button" [disabled]="loading" (click)="resetLogin()" class="mat-mdc-raised-button accent cancel">
                  {{'auth.cancel' | translate}}
                </button>
              </div>
            </section>
            <div class="footer-inner">
              <mat-divider class="divider-style-footer"></mat-divider>
              <div class="footer-content">
                <span>{{'auth.footerInnerText' | translate}}</span>
                <a href="https://play.google.com/store/apps/details?id=com.dais.software.mqes&hl=bg&gl=US"
                  target="_blank" title="Google play">
                  <span class="border-icon-app">
                    <!-- google play -->
                    <img src="../../../../../../assets/images/svg-icons/google-play-logo.svg">

                  </span>
                </a>
                <a href="https://apps.apple.com/bg/app/b-trust-mobile/id1324004217" target="_blank" title="App Store">
                  <span class="border-icon-app">
                    <!-- app store -->
                    <img src="../../../../../../assets/images/svg-icons/apps-apple-logo.svg">

                  </span>
                </a>
                <a href="https://appgallery.huawei.com/app/C104500903" target="_blank" title="App Gallery">
                  <span class="border-icon-app-g">
                    <!-- appGallery -->

                    <img src="../../../../../../assets/images/svg-icons/huawei-store-icon.svg">
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="!showContentLogin" class="content-box-loading">
          <mat-spinner></mat-spinner>
        </div>
      </div>
    </div>
  </div>
</div>